export default __webpack_public_path__ + "static/media/h3.771ee58d.jpg";